import AppLink from "@/integrations/next/components/AppLink"

export interface NavItemProps {
  children: any
  link?: string
  onClick?: () => void
  className?: string
}

const NavItem = ({ children, link, onClick, className }: NavItemProps) => {
  return (
    <AppLink href={link} onClick={onClick} className={className}>
      {children}
    </AppLink>
  )
}

export default NavItem
